import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PackTerm from '../pack-term/packTerm';
import GameLogic from './gameLogic';
import QueryStringParser from './queryStringParser';

import './game.css';

export default class Game extends Component {

  constructor(props) {
    super(props);

    this.isFirstRound = true;
    this.queryStringParser = new QueryStringParser();
    var queryTerms = this.queryStringParser.parse(window.location.search);

    this.gameLogic = new GameLogic(this.props.terms);
    var roundTerms;
    if (this.props.gameCount === 0 && queryTerms.first !== undefined) {
      roundTerms = this.gameLogic.getThreeDifferentTermsByName(queryTerms);
    } else {
      roundTerms = this.gameLogic.getFirstThreeTerms();
    }

    this.state = {
      previousTerm: roundTerms[0],
      currentTerm: roundTerms[1],
      nextTerm: roundTerms[2]
    };

    this.onHigherClicked = this.onHigherClicked.bind(this);
    this.onLowerClicked = this.onLowerClicked.bind(this);
  }

  componentDidMount() {
    if (this.props.onRoundAnswer) {
      let thisAnswer = this.gameLogic.currentValueIsHigherThanPrevious(this.state.currentTerm.searchVolume, this.state.previousTerm.searchVolume) ? 'higher' : 'lower';
      this.props.onRoundAnswer(thisAnswer);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.roundState === 'new' && !this.isFirstRound) {
      this.beginNewRound();
    }
  }

  onHigherClicked() {
   this.handleRoundStatus(this.gameLogic.currentValueIsHigherThanPrevious(this.state.currentTerm.searchVolume, this.state.previousTerm.searchVolume), 'higher');
  }

  onLowerClicked() {
    this.handleRoundStatus(this.gameLogic.currentValueIsLowerThanPrevious(this.state.currentTerm.searchVolume, this.state.previousTerm.searchVolume), 'lower');
  }

  handleRoundStatus(isCorrect, highOrLow) { 
    this.isFirstRound = false
    isCorrect ? this.props.onCorrectAnswer(highOrLow) : this.props.onIncorrectAnswer(highOrLow);
  }

  beginNewRound() {
    let nextAnswer = this.gameLogic.currentValueIsHigherThanPrevious(this.state.nextTerm.searchVolume, this.state.currentTerm.searchVolume) ? 'higher' : 'lower';
    if (this.props.onRoundAnswer) {
      this.props.onRoundAnswer(nextAnswer);
    }

    this.setState((prevState, props) => ({
        previousTerm: prevState.currentTerm,
        currentTerm: prevState.nextTerm,
        nextTerm: this.gameLogic.getNextTerm()
    }));
  }

  render() {
    return (<div className='game'>
      <div className={'game-scroller game-scroller--' + this.props.roundState}>
        <PackTerm term={this.state.previousTerm} />
        <PackTerm term={this.state.currentTerm} termType={this.props.answered === true ? 'new' : 'current'} />
        <PackTerm term={this.state.nextTerm} termType='current' />
      </div>
      {React.cloneElement(this.props.actions, { 
        higherClickHandler: this.onHigherClicked,
        lowerClickHandler: this.onLowerClicked,
        previousKeyword: this.state.previousTerm.keyword
      })} 
      {this.props.badge}
    </div>);
  }
}

Game.propTypes = {
  onIncorrectAnswer: PropTypes.func,
  onCorrectAnswer: PropTypes.func,
  terms: PropTypes.array,
  actions: PropTypes.element,
  badge: PropTypes.element,
  roundState: PropTypes.string, 
  answered: PropTypes.bool,
  gameCount: PropTypes.number,
  onRoundAnswer: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/game/game.js